import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchChecklist } from "./api";
import type { ChecklistItem } from "./api";

// Пункты чек-листа пары (org, repo). Org-scoped запрос (см.
// `src/query/scope.ts`); ключ несёт repoFullName (свой кэш на каждый
// репо). Запрос отключён без введённого репо — список появляется
// только после того, как человек ввёл `owner/repo`.
export function useChecklist(
  repoFullName: string,
): UseQueryResult<readonly ChecklistItem[], Error> {
  const trimmed = repoFullName.trim();
  return useOrgScopedQuery<readonly ChecklistItem[]>({
    key: ["reviewerChecklist", trimmed],
    queryFn: () => fetchChecklist(trimmed),
    enabled: trimmed.length > 0,
    retry: false,
  });
}
